import { Component, OnInit } from '@angular/core';
import { TagsService } from 'src/app/services/tags.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {
  public tagId;
  public tag;
  public loading:boolean=true;

  constructor(
    private _tag: TagsService,
    private _notify: NotificationService,
    private _activatedRoute: ActivatedRoute
  ) {
    this.tagId=this._activatedRoute.snapshot.paramMap.get('id');
  }

  getTag(){
    this._tag.getTag(this.tagId).subscribe(
      res=>{
        this.tag=res;
        this.loading=false;
      }
    );
  }

  updateTag(){
    if(this.tag.tag=='') return this._notify.showMessage('Tag can not be blank.','OK');
    this._tag.updateTag(this.tag).subscribe(res=>{
      if(res.id) this._notify.showMessage('Tag updated.', 'OK');
    });
  }

  ngOnInit() {
    this.getTag();
  }

}
